import { connect } from 'react-redux';
import { get } from 'lodash';
import { getCategories, getFeatured, getTools } from '../lib/containers';
import MyApps from '../components/MyApps';
import Tracking from '../lib/fpti';
import dataFetcher from './DataFetcher';
import * as MyAppsActions from '../actions/myapps';
import * as SmartRecActions from '../actions/smartrec';
import * as AppActions from '../actions/app';
import * as TrackingActions from '../actions/tracking';

const mapStateToProps = state => {
  return {
    categories: getCategories(state),
    categoryIndexes: get(state, 'metadata.categoryIndexes', {}),
    favorites: get(state, 'myapps.favorites', []),
    activeKey: get(state, 'myapps.activeKey', '0'),
    app: get(state, 'app', {}),
    tracking: Tracking,
    tools: getTools(state),
    search: get(state, 'myapps.search', {}),
    recommendations: get(state, 'myapps.recommendations', []),
    featured: getFeatured(state),
    experimentation: get(state, 'experimentation', {}),
    path: get(state, 'myapps.path', '')
  };
};

const mapDispatchToProps = dispatch => ({
  ...MyAppsActions,
  ...AppActions,
  ...TrackingActions,
  ...SmartRecActions,
  dispatch
});

const Wrapper = dataFetcher(MyApps, [MyAppsActions.fetchTools]);
export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
